document.addEventListener('DOMContentLoaded',function(){
  // 三级菜单
  if(window.screen.width > 1024){
    $("header nav ul li details .mega-menu .thirdMenu li").hover(
      function(){
          $("header nav ul li details .mega-menu .thirdMenu li").removeClass("active").siblings("section").fadeOut(300)
          $(this).addClass("active").next("section").fadeIn(300)
      })
  }

  // 移动端-头部
  if(window.screen.width < 1024){
    // $(".header__link-list details").click(function(){
    //     if($(this).attr("open") != undefined && $(this).attr("open") == "open"){
    //       console.log("111")
    //       $(this).attr("open","no-open").find(".dropdown-menu").css("opacity","0")
    //     }else{
    //       console.log("222")
    //       $(this).attr('open','open').find(".dropdown-menu").css("opacity","1")
    //     }
    // })

    $(".header__main-nav button .icon-hamburger").click(function(){
      $("nav.header__link-list").fadeIn(300)
      $(".header__main-nav .icon-hamburger").hide()
      $(".header__main-nav .header-menu-close").show()
      $("body").addClass("menu-open")
    })

    $(".header-menu-close").click(function(){
      $("nav.header__link-list").fadeOut(300)
      $(".header__main-nav .icon-hamburger").show()
      $(".header__main-nav .header-menu-close").hide()
      $("body").removeClass("menu-open")
    })


    $("nav.header__link-list .thirdMenu li").removeClass("active")
    $(".dropdown-menu__item").click(function(e){
       var $target = $(e.target);
        if ($target.closest('span').length > 0) {
          return; 
        } else {
          e.preventDefault();

          if($(this).attr("dropdown-show") == "false"){
            $(this).parent("li").addClass("active").next("section").fadeIn(300)
            $(this).attr("dropdown-show","true")
            
          }else{
            $(this).parent("li").removeClass("active").next("section").fadeOut(300)
            $(this).attr("dropdown-show","false")
          }
          
        }
    })
  }

  // 移动端-底部
  if(window.screen.width < 1024){
      $(".footer_menu_head").click(function(){
          if($(this).parent().attr("data-show")=='false'){
              $(this).parent().attr("data-show","true").find("ul").slideDown(300)
              $(this).parent().siblings().attr("data-show","false").find("ul").slideUp(300)
          }else{
              $(this).parent().attr("data-show","false").find("ul").slideUp(300)
          }
      })
  }
})


// 回到顶部
$(window).scroll(function () {
  if ($(this).scrollTop() > 300) {
      $('#back-to-top').fadeIn();
  } else {
      $('#back-to-top').fadeOut();
  }
});

$('#back-to-top').click(function () {
    $('html, body').animate({
        scrollTop: 0
    }, 800);
});

